module.exports = __webpack_public_path__ + "static/img/about.6589c4da.png";